<input
  #input
  payee-input
  [value]="value"
  [placeholder]="placeholder"
  (input)="change(input.value)"
/>
<button
  payee-suffix
  payee-copy-button
  aria-label="Copy"
  [input]="input"
></button>
